<template>
	<div
		:class="`formulate-input-element formulate-input-element--${context.class} formulate-radio-group-buttons`"
		:data-type="context.type"
	>
		<div class="btn-group">
			<template v-for="option in context.options">
				<b-button
					:key="option.id"
					type="button"
					class="btn"
					:variant="model === option.value ? 'primary' : 'outline-primary'"
					@click="handleChange(option.value)"
				>
					{{ option.label }}
				</b-button>
			</template>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			model: null,
		};
	},
	mounted() {
		if (!this.context.model) this.context.model = null;
	},
	methods: {
		handleChange(event) {
			this.model = event;
			this.context.model = event;
		},
	},
};
</script>
<style lang="scss">
.formulate-radio-group-buttons {
	.formulate-input-errors {
		top: 100%;
	}
}
</style>
